module.exports = __webpack_public_path__ + "images/revo_bg-54775c31a0fce5dc1ba3a58caed01387.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/revo_bg.png
// module id = 755
// module chunks = 0